var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideNavigationTransactionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49994 15.2499C7.30994 15.2499 7.11994 15.1799 6.96994 15.0299C6.67994 14.7399 6.67994 14.2599 6.96994 13.9699L10.1699 10.7699C10.3299 10.6099 10.5399 10.5299 10.7699 10.5499C10.9899 10.5699 11.1899 10.6899 11.3199 10.8799L12.4099 12.5199L15.9599 8.96994C16.2499 8.67994 16.7299 8.67994 17.0199 8.96994C17.3099 9.25994 17.3099 9.73994 17.0199 10.0299L12.8199 14.2299C12.6599 14.3899 12.4499 14.4699 12.2199 14.4499C11.9999 14.4299 11.7999 14.3099 11.6699 14.1199L10.5799 12.4799L8.02994 15.0299C7.87994 15.1799 7.68994 15.2499 7.49994 15.2499Z",
    fill: "#0D0706"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.25C16.09 12.25 15.75 11.91 15.75 11.5V10.25H14.5C14.09 10.25 13.75 9.91 13.75 9.5C13.75 9.09 14.09 8.75 14.5 8.75H16.5C16.91 8.75 17.25 9.09 17.25 9.5V11.5C17.25 11.91 16.91 12.25 16.5 12.25Z",
    fill: "#0D0706"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#0D0706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideNavigationTransactionsIcon);
export default __webpack_public_path__ + "static/media/side-navigation-transactions-icon.a57b5af1942ee1c9c02d8857e6a933a3.svg";
export { ForwardRef as ReactComponent };